export const getIriFromUuid = (entityName: string, uuid?: string) => {
  /* iri string syntax::
        /api/patients/b657502b-e995-4c69-a8ed-8633a054d63a

        returns only iri part b657502b-e995-4c69-a8ed-8633a054d63a
    */
  return `/api/${entityName}/${uuid}`;
};
